import PageContainer from '@components/blog/pages/PageContainer'
import HeroImage from '@components/blog/components/HeroImage'
import HtmlContent from '@components/blog/components/HtmlContent'
import PostSearchSimpleWidget from '@components/blog/components/search/PostSearchSimpleWidget'
import PostList from '@components/blog/components/PostList'
import Pagination from '@components/pagination/RouterPagination'
import withBreakpoints from '@hoc/withBreakpoints'
import { useSidebarComponents } from '@components/blog/components/sidebar/Sidebar'
import monthAsText from '@utils/date/monthAsText'
import FrontpageLinks from '@components/frontpage/FrontpageLinks'
import makeCategoryLink from '@components/frontpage/functions/makeCategoryLink'
import AddOfferButton from './AddOfferButton'

import styles from '../styles/LinkWrap.module.css'

function PostsAll (props) {
    const {
        additionalContent,
        breakpoints: { onMobile },
        data,
        initialParams,
        loading,
        onChange,
        pagination,
        sidebar,
        seo } = props

    const docType = initialParams.category || null

    const heroProps = { docType, onMobile }
    const htmlContentProps = {
        docType,
        h1: resolveH1(seo, initialParams),
        onMobile,
    }

    const searchParams = { initialParams, loading, onChange }
    const postListProps = { data, loading }

    // const strona = initialParams?.strona
    const isMainPage = Boolean(docType === null && !initialParams.rok && !initialParams.tagi)
    const displayAddButton = Boolean(!initialParams.rok && !initialParams.tagi)
    const displayTags = isMainPage // && (!strona || strona < 2)
    const displayAddButtonOnTop = onMobile
    const displayAddButtonOnBottom = !displayAddButtonOnTop
    const [categories, years, tags] = useSidebarComponents(sidebar, onMobile, displayTags)

    const mainSidebar = <>
        { categories }
        { !onMobile && years }
    </>

    const addButton = displayAddButton && <AddOfferButton />

    const bottomSidebar = <>
        { onMobile && years }
        { tags }
    </>

    return <>
        { displayAddButtonOnTop && addButton }
        <PageContainer
            hero={ <HeroImage {...heroProps} /> }
            html={ <HtmlContent {...htmlContentProps} /> }
            sidebar={ mainSidebar }>

            <Pagination {...pagination} onEachSide={onMobile
                    ? 1
                    : 3 }>
                <PostSearchSimpleWidget {...searchParams} />
                <br/><br/>
                <PostList {...postListProps} />
            </Pagination>

            { docType && <div className={styles.wrap}>
                <FrontpageLinks sections={[makeCategoryLink('Informacje motoryzacyjne','/informacje-motoryzacja')]} />
            </div> }
        </PageContainer>

        { displayAddButtonOnBottom && addButton }
        { additionalContent }
        { bottomSidebar }
    </>
}

function resolveH1 (seo, { category, miesiac, rok, tagi } = {}) {
    if (seo?.h1) return seo.h1
    if (rok) {
        const text = [miesiac != null && monthAsText(parseInt(miesiac)), rok]
            .filter(Boolean)
            .join(' ')

        return `Wpisy na blogu motoryzacyjnym - ${text} r.`
    }
    if (tagi) return tagi.replace(/[-]+/g, ' ')
    if (!category) return 'Informacje motoryzacyjne'
    return ''
}

export default
    withBreakpoints({ onMobile: 800 })(
        PostsAll)